import PropTypes from "prop-types";
import {Dropdown} from "primereact/dropdown";



export function CustomerGroupCategorySelect(props) {
    const catList = [{value: "T", name: "Transaction"}, {value: "E", name: "Expenses"}, {value: "B", name: "Bank"},
        {value: "D", name: "Drawing"}, {value: "S", name: "Storage"}, {value: "U", name: "Buffer"}, {value: "A", name: "Asset"}, {value: "I", name: "Import"},
        {value: "M", name: "Manufacturing"}];
    const handleChange = (event) => {
        const myValue = catList.find(x => x.value === event.target.value)
        props.setGroupCat(myValue);

    };

    return (

            <Dropdown value={props.groupCat.value} onChange={handleChange} options={catList}
                      optionLabel="name" optionValue="value" disabled={props.disable}
                      panelClassName=" flex-1 " variant="filled" className="flex h-2rem justify-content-center align-items-center"/>

    )

}

CustomerGroupCategorySelect.propTypes = {
    groupCat: PropTypes.object.isRequired,
    setGroupCat: PropTypes.func.isRequired,
    disable: PropTypes.bool.isRequired,


}
